import styled from 'styled-components';

const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-top: ${(p) => p.theme.colors.gray600} 1px solid;
`;

export default SwitchContainer;
